import React from 'react';
export default function SliderLeftArrow() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", stroke: "none", width: "15", height: "27", viewBox: "0 0 15 27" },
        React.createElement("g", { fillRule: "evenodd" },
            React.createElement("path", { fillRule: "nonzero", d: "M14.258 1.53L13.198.47-.061 13.728l13.259 13.258 1.06-1.06L2.061 13.728z" }))));
}
//# sourceMappingURL=sliderLeftArrow.js.map